import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import dropdown from 'scoreboard/components/dropdown'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

function renderDefaultCalendarField({ el, labelContainer, fields, currValue }) {
	let dateFields = _(fields)
		.filter(field => {
			return _.get(field, 'dataType') === DATE && !_.isNil(field.id)
		})
		.sortBy(field => field.label.toLocaleUpperCase())
		.value()
	// add "None (Show all time)" option
	dateFields = [{
		id: '',
		label: i18n.get('datasets.calendarField.none')
	}].concat(dateFields)
	labelContainer.toggleClass('is-not-displayed', _.isEmpty(dateFields))

	let selected
	if (currValue) {
		selected = _.get(_.find(dateFields, field =>
			field.id === parseInt(currValue)), 'id')
	}
	if (!_.isEmpty(dateFields)) {
		var select = el.empty()
		dropdown.idLabels(select, dateFields, selected)
	}
}

export default renderDefaultCalendarField
renderDefaultCalendarField.__filename__ = 'datasets/edit/render-default-calendar-field.js'
